"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlToChannel = void 0;
var tslib_1 = require("tslib");
var get_url_to_widget_1 = tslib_1.__importDefault(require("./get-url-to-widget"));
var getUrlToChannel = function (_a) {
    var siteUrl = _a.siteUrl, compId = _a.compId;
    return (0, get_url_to_widget_1.default)(siteUrl, compId);
};
exports.getUrlToChannel = getUrlToChannel;
//# sourceMappingURL=get-url-to-channel.js.map